import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { DriverProfileService } from 'src/app/services/driver-profile/driver-profile.service';
import { LoginService } from 'src/app/services/login/login.service';

interface Driver {
  userID: string;
}
@Component({
  selector: 'app-driver-home',
  templateUrl: './driver-home.page.html',
  styleUrls: ['./driver-home.page.scss'],
})
export class DriverHomePage implements OnInit {
  userID;
  profile;

  constructor(
    private menu: MenuController,
    private router: Router,
    private auth: AngularFireAuth,
    private profileService: DriverProfileService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.auth.authState.subscribe((user) => {
      if (user) {
        this.userID = user.uid;
        this.profileService
          .getProfile(this.userID)
          .pipe(take(1))
          .subscribe((res) => {
            if (res.exists) {
              this.profile = res.data() as Driver;
            } else {
              this.router.navigate(['/home/login']);
            }
          });
      } else {
        this.router.navigate(['/home/login']);
      }
    });
  }

  openDriver(menu) {
    this.menu.enable(true, 'dash' + menu);
    this.menu.open('dash' + menu);
  }

  userProfile() {
    this.router.navigate(['driver-home']);
  }
  request() {
    this.router.navigate(['driver-request']);
  }
  history() {
    this.router.navigate(['driver-history']);
  }
  edit() {
    this.router.navigate(['driver-edit']);
  }

  logout() {
    this.loginService.logout();
  }
}
